import { render } from "./CardWithCloseButton.vue?vue&type=template&id=016324f4"
import script from "./CardWithCloseButton.vue?vue&type=script&lang=js"
export * from "./CardWithCloseButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__